import { render, staticRenderFns } from "./CodSettings.vue?vue&type=template&id=12c79bbd&"
import script from "./CodSettings.vue?vue&type=script&lang=js&"
export * from "./CodSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports